export default __webpack_public_path__ + "static/media/cold.5b68478d.png";